var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHusaNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73451 0L17.5 8.43337L26.2965 0L35 8.43337V12.7251L26.2965 4.2617L17.5 12.7251L10.4071 5.91236V8.64346L17.5 15.4562L26.2965 7.02281L35 15.4562V25H17.5V19.7179L10.4381 12.9352V25H7.06195V12.9352L0 19.7479V15.4862L7.06195 8.67347V5.97239L0 12.7851V8.43337L8.73451 0ZM32 22V16.9713L26.5629 12L21 17.0287V22H32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHusaNoBg);
export default __webpack_public_path__ + "static/media/logo-husa-no-bg.8c9bdc24.svg";
export { ForwardRef as ReactComponent };